import { useState } from 'react';
import { fetchServerConfig } from '@/services';
import { useModel } from '@umijs/max';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import defaultSettings from '../../config/defaultSettings';

export default () => {
  const { setInitialState } = useModel('@@initialState');
  const [settingList, pureSetSettingList] = useState<any[]>([]);

  const getConfig = (key: string, list = settingList): { [key: string]: any } => {
    try {
      const data = JSON.parse(list?.find((item) => item.key === key)?.value);
      return data || {};
    } catch {
      return {};
    }
  };

  const setSettingList = (list: any[]) => {
    const oldFavIcon = getConfig('fav_icon', settingList)?.data || '/placeholder.png';
    const newFavIcon = getConfig('fav_icon', list)?.data || '/logo.png';
    if (oldFavIcon !== newFavIcon) {
      const link: HTMLLinkElement =
        document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = newFavIcon;
      link.remove();
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    pureSetSettingList([...list]);
  };

  const fetchSettingList = async () => {
    try {
      const res = await fetchServerConfig();
      const list = res.content || [];
      setSettingList(list);
      const webLogo = getConfig('fav_icon', list);
      const title = getConfig('title', list);
      setInitialState((s) => ({
        ...s,
        settings: {
          ...((s?.settings || defaultSettings) as Partial<LayoutSettings>),
          logo: webLogo.data || '/logo.png',
          title: title.data || 'AI辅助值守平台',
        },
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const frequency = getConfig('wall-frequency', settingList);
  const wallLogo = getConfig('wall-logo', settingList);
  const fixedWallLogo = getConfig('wall-fixed-logo', settingList);
  const webLogo = getConfig('fav_icon', settingList);
  const copyright = getConfig('copyright', settingList);
  const title = getConfig('title', settingList);

  return {
    settingList,
    wallFrequency: parseInt(frequency.interval) || 3,
    wallLogo: wallLogo.data || '',
    fixedWallLogo: fixedWallLogo.data || '',
    webLogo: webLogo.data || (settingList.length ? '/logo.png' : '/placeholder.png'),
    company: copyright.data || '小飞象科技',
    title: title.data || 'AI辅助值守平台',
    setSettingList,
    fetchSettingList,
  };
};
